import { useMemo } from "react";
import { useIntl } from "react-intl";
import { getLocaleCurrencySymbol } from "../../../common/currencyHelpers";
import messages from "./messages";
import { Translations } from "./types";

const useTranslations = (params: {
  currencyCode: string;
  offeringsPrice: number;
  durationMinutes: number;
}) => {
  const { currencyCode, offeringsPrice, durationMinutes } = params;
  const { formatMessage, formatNumber, locale } = useIntl();

  const translations: Translations = useMemo(() => {
    const currencySymbol = getLocaleCurrencySymbol(currencyCode, locale);

    const price = formatNumber(offeringsPrice, {
      style: "currency",
      currency: currencyCode,
    }).replace(".00", "");

    const duration = `${durationMinutes} ${formatMessage(messages.minutes)}`;

    return {
      visibilityPrivate: formatMessage(messages.visibilityPrivate),
      visibilityPublic: formatMessage(messages.visibilityPublic),
      textPrice: formatMessage(messages.textPrice, { price }),
      helperPrice: formatMessage(messages.helperPrice),
      duration: formatMessage(messages.duration),
      textDuration: formatMessage(messages.textDuration, { duration }),
      currencySymbol,
      helperDuration: formatMessage(messages.helperDuration),
      minutes: formatMessage(messages.minutes),
    };
  }, [
    currencyCode,
    durationMinutes,
    formatMessage,
    formatNumber,
    locale,
    offeringsPrice,
  ]);
  return translations;
};
export default useTranslations;
